/**
 * 选图结果 settle：in-app 环境下对 File 做 stabilize（arrayBuffer 克隆），
 * 避免 WebView 在 input 清空后 blob 失效。
 *
 * Web 环境直接透传；Android 开弹窗前与 Host pick 共用；弹窗内 +Upload 用
 * `preparePortfolioUploadFiles`（含校验维度更多）。
 */
import { getBridge } from "@/src/lib/bridge/bridge";
import type { PortfolioUploadType } from "@/src/components/PortfolioScreenshotModal/types";
import { stabilizePickedFiles } from "../../upload/stabilizePickedFiles";

export async function settlePickedPortfolioFiles(
  uploadType: PortfolioUploadType,
  picked: File[],
): Promise<File[] | null> {
  const bridge = getBridge();
  const stable = bridge.isInApp()
    ? await stabilizePickedFiles(picked, {
        defaultMimeType:
          uploadType === "pdf" ? "application/pdf" : "image/jpeg",
      })
    : picked;

  return stable.length > 0 ? stable : null;
}
